import "@creativebulma/bulma-tooltip/dist/bulma-tooltip.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Amplify from "aws-amplify";
import { createApp } from "vue";
import VueGtag from "vue-gtag-next";
import { createI18n } from "vue-i18n";
import App from "./App.vue";
import awsconfig from "./aws-exports.js";
import imsrconfig from "./imsr-exports.js";
import router from "./router";
import store from "./store";

Amplify.configure(awsconfig);

let store_locale = store.getters.locale;
if (store_locale == null) store_locale = window.navigator.language;
const i18n = new createI18n({
  locale: store_locale,
  messages: {
    ja: require("./locales/ja.json"),
    "en-US": require("./locales/en-US.json"),
  },
  fallbackLocale: "en-US",
});

const app = createApp(App)
  .use(i18n)
  .use(store)
  .use(router);

if (imsrconfig.ga4Id !== "") {
  app.use(VueGtag, {
    property: {
      id: imsrconfig.ga4Id,
    },
  });
}

app.mount("#app");
